import React from 'react';
import { ObjectView } from 'react-object-view';

const ObjectViewer = (props) => {
  const { data } = props;
  return (
    <div className='p-4' style={{ overflowX: 'auto' }}>
      <ObjectView data={data} />
    </div>
  );
};

export default ObjectViewer;
